<template>
    
  <div class="injiaotong">
      
    <div class="head">
      <div class="title">{{ contentTitle }}</div>
      <div class="dibu">
        <div class="time">时间: {{ time }}</div>
        <div class="from" v-if="data.hasOwnProperty('source')">
          来源：{{ data.source }}
        </div>
      </div>
    </div>
    <div class="content" v-html="content"></div>
    <div class="dibuShare">
      <div class="indibu">
        <div class="left">
          <div class="img">
            <img src="../assets/images/kunshanIcon.png" alt="" />
          </div>
          <div class="word">鹿路通</div>
        </div>
        <div class="right">
          <div class="xiazaiBtn" @click="goXiazai">下载</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Swipe, SwipeItem } from "vant";
import { Field } from "vant";
import { Overlay } from "vant";
import { Popup } from "vant";
import qs from "qs";
import { Toast } from "vant";
import { Dialog } from "vant";
Vue.use(Popup);

Vue.use(Overlay);

Vue.use(Field);

Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  mounted() {
    this.getInjiaotongContent();
    document.querySelector("html").removeAttribute("style");
  },
  data() {
    return {
      isShowShare: false,
      content: "",
      title: "",
      neirong: "一个App畅享全市政务服务",
      src: "",
      type1: "wxhy",
      type2: "wxpyq",
      type3: "wb",
      type4: "qqhy",
      type5: "qqkj",
      contentTitle: "",
      time: "",
      from: "",
      data: Object,
    };
  },
  methods: {
    goXiazai() {
      this.$router.push("Saoyisao");
    },
    getYMDHMS(timestamp) {
      let time = new Date(timestamp);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let date = time.getDate();
      let hours = time.getHours();
      let minute = time.getMinutes();
      let second = time.getSeconds();

      if (month < 10) {
        month = "0" + month;
      }
      if (date < 10) {
        date = "0" + date;
      }
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (second < 10) {
        second = "0" + second;
      }
      return year + "-" + month + "-" + date;
    },

    getInjiaotongContent() {
      this.$toast.loading({
        message: "信息获取中...",
        forbidClick: true,
      });
      let params = qs.stringify({
        metacode: "TRANSPORTATION",
        id: this.$route.query.contentId,
      });
      this.$axios
        .post("appapi/cmsInterface/getCmsInfo", params)
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
            Toast.clear();
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            this.content = res.data.data.content;
            this.contentTitle = res.data.data.title;
            res.data.data.pubtime = this.getYMDHMS(res.data.data.pubtime);
            this.time = res.data.data.pubtime;
            this.data = res.data.data;

            Toast.clear();
          }
        })
        .catch((err) => {
          Toast.clear();
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    showShare() {
      this.isShowShare = true;
    },
    noShare() {
      this.isShowShare = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 0 15px !important;
}
.content ::v-deep img {
  width: 330px;
  height: auto;
}
.injiaotong {
  background-color: #fff;
}
.head {
  padding: 13px 16px 0 16px;

  .title {
    color: #19212a;
    font-size: 22px;
    line-height: 32px;
    font-weight: 500;
  }
  .dibu {
    display: flex;
    align-items: center;
    margin-top: 12px;
    padding-bottom: 11px;
    .time {
      color: #878787;
      font-size: 13px;
    }
    .from {
      color: #878787;
      font-size: 13px;
      margin-left: 1rem;
    }
  }
}
.share {
  width: 50px;
  height: 50px;
  background: #ffffff;
  box-shadow: 0px 0px 12px rgba(67, 219, 181, 0.25);
  position: fixed;
  bottom: 65px;
  right: 16px;
  border-radius: 2000px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 22px;
  }
}
.shareWayList {
  padding: 0 8px 12px 8px;
  display: flex;
  flex-wrap: wrap;
  .everyShare {
    width: 25%;
    display: flex;
    justify-content: center;
    margin-top: 24px;
    .shareIcon {
      img {
        width: 52px;
      }
    }
    .shareName {
      color: #555555;
      font-size: 13px;
      margin-top: 8px;
      text-align: center;
    }
  }
}
.fenge {
  width: 100%;
  height: 10px;
  background: #eef4f6;
}
.dibuQuxiao {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 51px;
  .word {
    color: #19212a;
    font-size: 16px;
  }
}
.dibuShare {
  width: 100%;
  height: 55px;
  position: fixed;
  bottom: 0;
  background-color: #fff;
  box-shadow: 0px 0px 12px rgba(67, 219, 181, 0.25);
  padding: 0 19px 0 16px;
  display: flex;
  align-items: center;
  .indibu {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      display: flex;
      align-items: center;
      img {
        width: 38px;
      }
      .word {
        margin-left: 9px;
        color: #555555;
        font-size: 16px;
        font-weight: bold;
        white-space: nowrap;
      }
    }
    .right {
      .xiazaiBtn {
        padding: 5px 24px;
        background: linear-gradient(90deg, #19a0a0 0%, #0f7876 100%);
        border-radius: 22px;
        color: #ffffff;
        font-size: 14px;
      }
    }
  }
}
.content {
  margin-bottom: 150px;
}
</style>

